export enum TAB_NAVIGATION_ORIENTATIONS {
    HORIZONTAL,
    VERTICAL,
}
